import { useTranslation } from 'react-i18next';

import styles from './ChartTooltip.module.css';

function ChartTooltip({point, unit}) {
  const {t} = useTranslation();
  return (
    <div key={point.id} className={styles.ChartTooltip}>
      <div className={styles.TooltipTime}>{point.data.x.toLocaleString('en-AU')}</div>
      <div className={styles.TooltipValue} style={{color: point.serieColor}}>{t(`charts.series.${point.serieId}`)}: {point.data.y} {unit}</div>
    </div>
  )
}

export default ChartTooltip
